
	import {
		Component,
		Vue,
		Inject,
		Prop,
		Watch
	} from 'vue-property-decorator';
	import AbpBase from '@/lib/abpbase';
	@Component({
		components: {

		}
	})
	export default class iLearning extends AbpBase {

	}
